/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const  filterData =  (data) => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getFilterData.url+"/"+data.payload,
        maverickPortalApiEndPoint.getFilterData.methodType,
      )
      .then(response => {        
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        resolve({ res });
      });
  });
};

const deleteCustomtag = (data) => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.deleteCustomtag.url,
        maverickPortalApiEndPoint.deleteCustomtag.methodType,
        data
      )
      .then(response => {
        const res = response.data;
        if (response.data.Response !== undefined) {
        } else if (response.data?.Status && response.data?.Status.StatusCode === -2) {
          localStorage.removeItem('token');
          history.push('/#/sign-in');
          resolve({ res });
        } else {
          console.log(response.data?.Status && response.data?.Status.StatusDesc ? response.data?.Status.StatusDesc : 'Error');
        }

        resolve({ res });
      });
  });
}

const editCustomTagName = (data) => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.editCustomTagName.url,
        maverickPortalApiEndPoint.editCustomTagName.methodType,
        data
      )
      .then(response => {
        const res = response.data;
        if (response.data.Response !== undefined) {
        } else if (response.data?.Status && response.data?.Status.StatusCode === -2) {
          localStorage.removeItem('token');
          history.push('/#/sign-in');
          resolve({ res });
        } else {
          console.log(response.data?.Status && response.data?.Status.StatusDesc ? response.data?.Status.StatusDesc : 'Error');
        }

        resolve({ res });
      });
  });
}

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { filterData, deleteCustomtag, editCustomTagName };
